var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.AnalyticsSubPage,{attrs:{"title":"Safeguarding","icon":"shield-check","css-class":"analytics-safeguarding","default-label":"Safeguarding","show-divisions-dropdown":false,"section-specs":_setup.sectionSpecs}},[_c(_setup.SafeguardingMetrics,{ref:"safeguardingRef"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }